import ppUtilities from '../ppUtilities.js';
import {
	ITEMS_IN_THE_CART,
	ITEM_ADDED_TO_YOUR_CART,
	ITEMS_ADDED_TO_YOUR_CART,
	ITEM_IN_THE_CART,
	CAR_TOTAL,
	CAR_CHECKOUT_LINK,
	CART_URL,
} from '../data/Localization.js';

function ShoppingCartBanner(cart, itemsAdded, callback) {
	let $body = jQuery('body');
	const main = $('#main-content');
	const secNav = document.querySelector('.es-nav-wrapper') || document.querySelector('.local-navigation');
	let clonSecNav;
	if (secNav) {
		clonSecNav = secNav.cloneNode(true);
	}
	// add
	let bannerAppElm = document.querySelector('.products-cart-banner');
	let utils = new ppUtilities();
	let cartItems = cart.lineItems;
	let formattedLocale = cart.metadata.formattedLocale;
	let currency = cart.metadata.currency;
	let itemsAddedText = itemsAdded > 1 ? ITEMS_ADDED_TO_YOUR_CART : ITEM_ADDED_TO_YOUR_CART;
	let storeVariables = window.storeVariables;

	function init() {
		let cart = {};
		cart.totalItems = calcTotalItems();
		cart.totalAmount = calcTotalAmount();
		cart.itemsAdded = itemsAdded;
		render(cart);
	}

	function onAppMounted() {
		cartBannerAnimation(itemsAdded);
		showHideShoppingBanner();
		if (callback) {
			callback();
		}
	}

	function cartBannerAnimation(itemsAdded) {
		let newBanner = document.querySelector('.products-cart-banner');
		let pcbInfo = newBanner.querySelector('.pcb-info');
		let itemsAddedElm = pcbInfo.querySelector('.pcb-number-items-added');
		let itemsQty = pcbInfo.querySelector('.pcb-number-items');
		let cartQty = pcbInfo.querySelector('.pcb-cart-qty');
		// let itemsTotal = pcbInfo.querySelector('.pcb-total');
		let globalNav = document.querySelector('#globalnav');

		if (newBanner) {
			let gnTop = globalNav.getBoundingClientRect().top;
			if (gnTop == 0) {
				newBanner.classList.add('under');
			} else {
				newBanner.classList.remove('under');
			}
			if (itemsAdded) {
				fullAnimationSteps();
			} else {
				// if cart exist on load
				shortAnimationSteps();
			}
		}

		function shortAnimationSteps() {
			pcbInfo.addEventListener(
				'animationend',
				(e) => {
					if (e.target.classList.contains('pcb-info')) {
						newBanner.classList.add('anim-phase-two-short');
						animateCart();
						itemsAddedElm.classList.add('hidden');
						itemsQty.classList.remove('hidden');
						// itemsTotal.classList.remove('hidden');
					}
				},
				false
			);
			newBanner.classList.add('anim-phase-one');
		}

		function fullAnimationSteps() {
			pcbInfo.addEventListener(
				'animationend',
				(e) => {
					if (e.target.classList.contains('pcb-info')) {
						newBanner.classList.add('anim-phase-two');
						animateCart();
					}
				},
				false
			);

			cartQty.addEventListener('animationend', (e) => {
				if (e.target.classList.contains('pcb-cart-qty')) {
					itemsAddedElm.classList.add('animation-done');
					newBanner.classList.add('anim-phase-three');
				}
			});

			itemsAddedElm.addEventListener('animationend', (e) => {
				if (e.target.classList.contains('animation-done')) {
					itemsAddedElm.classList.add('hidden');
					itemsQty.classList.remove('hidden');
					// itemsTotal.classList.remove('hidden');
				}
			});

			// itemsTotal.addEventListener('animationend', (e) => {
			// 	if (e.target.classList.contains('pcb-total')) {
			// 		newBanner.classList.add('anim-phase-four');
			// 	}
			// });
			newBanner.classList.remove('anim-phase-two-short');
			newBanner.classList.add('anim-phase-one');
		}

		function animateCart() {
			let pulseElm = newBanner.querySelector('.pcb-cart-qty');
			pulseElm.addEventListener(
				'animationend',
				() => {
					pulseElm.setAttribute('data-cart-updated', 'false');
				},
				false
			);
			pulseElm.setAttribute('data-cart-empty', 'false');
			pulseElm.setAttribute('data-cart-updated', 'true');
		}
	}

	function showHideShoppingBanner() {
		let globalNav = document.querySelector('#globalnav');
		let cartBanner = document.querySelector('.products-cart-banner');
		let cookieBanner = document.querySelector('#esri-cookie-notification [data-position="top"]');
		if (globalNav) {
			checkGlobalNavPos();
			window.addEventListener('scroll', () => {
				cartBanner.classList.remove('under');
				checkGlobalNavPos();
			});
		}

		function checkGlobalNavPos() {
			let topbndry = globalNav.getBoundingClientRect().top;
			if (cookieBanner) {
				topbndry = cookieBanner.getBoundingClientRect().top;
			}
			if (topbndry == 0) {
				cartBanner.classList.add('anim-revert');
				if (secNav) {
					secNav.classList.remove('hidden');
				}
			} else {
				cartBanner.classList.remove('anim-revert');
				if (secNav) {
					secNav.classList.add('hidden');
				}
			}
		}
	}

	function calcTotalItems() {
		let accumulator = 0;
		cartItems.forEach((currentValue) => {
			accumulator = accumulator + currentValue.quantity;
		});
		return accumulator;
	}

	function calcTotalAmount() {
		let accumulator = 0;
		cartItems.forEach((currentValue) => {
			let itemTotal = currentValue.quantity * currentValue.price;
			accumulator = accumulator + itemTotal;
		});
		return utils.formatStorePrice(accumulator, formattedLocale, currency);
	}

	function render(cart) {
		let totalItemsAdded = cart.totalItems > 1 ? ITEMS_IN_THE_CART : ITEM_IN_THE_CART;
		let shoppingCartBanner = `<div class="grid-container pcb-container">
                <div class="pcb-info">
                    <p class="pcb-number-items-added avenir-regular font-size-0">${cart.itemsAdded} ${itemsAddedText}</p>
                    <p class="pcb-number-items avenir-regular font-size-0 hidden">${cart.totalItems} ${totalItemsAdded}</p>

                    <div class="pcb-cart">
                        <a class="pcb-cta-link" href="${storeVariables.cartUrl}">
                            <span class="pcb-cart-icon icon-cart">
                                <svg class="pcb-shopping-cart--image" role="presentation" style="transform: rotate(360deg);"><path d="M19.93 19.07A1.497 1.497 0 0 0 18.5 18H6.416a.5.5 0 0 1-.422-.768l.793-1.25 14.11-1.01L23.141 6H5.345L5.06 4.37a1.51 1.51 0 0 0-1.307-1.23L2.543 3H1.24l-.097.847 2.497.286a.502.502 0 0 1 .435.41l1.9 10.853-.826 1.301A1.497 1.497 0 0 0 6 18.94v.153a1.5 1.5 0 1 0 1 0V19h11.5a.497.497 0 0 1 .356.15 1.502 1.502 0 1 0 1.074-.08zM5.52 7h16.34l-1.757 7.027-13.188.942zM7.1 20.2v.6a.3.3 0 0 1-.3.3h-.6a.3.3 0 0 1-.3-.3v-.6a.3.3 0 0 1 .3-.3h.6a.3.3 0 0 1 .3.3zm13 .6a.3.3 0 0 1-.3.3h-.6a.3.3 0 0 1-.3-.3v-.6a.3.3 0 0 1 .3-.3h.6a.3.3 0 0 1 .3.3z"></path></svg>
                            </span>
                            <span class="pcb-cart-qty" data-cart-empty="true">${cart.totalItems}</span>
                            <calcite-button appearance="transparent" class="pcb-cart-checkout">
                                <span class="pcb-cart-checkout__wrapper">
                                    <span>${CAR_CHECKOUT_LINK}</span>
                                    <calcite-icon icon="arrowRight" class="pcb-cart-checkout__icon" scale="s"><calcite-icon>
                                </span>
                            </calcite-button>
                        </a>
                    </div>
                </div>
            </div>`;
		let shoppingBannerShell = `<div class="products-cart-banner pcb">${shoppingCartBanner}</div>`;

		if (bannerAppElm) {
			let bannerParent = document.querySelector('.products-cart-banner');
			bannerParent.setAttribute('class', ''); /* reset animation classes */
			// bannerParent.classList.add('products-cart-banner', 'pcb');
			bannerParent.setAttribute('class', 'products-cart-banner pcb');
			jQuery(bannerAppElm).html(shoppingCartBanner);
			if (clonSecNav && bannerParent) {
				jQuery(bannerParent).append(jQuery(clonSecNav));
			}
		} else {
			const root = main?.length ? main : $body;
			root.prepend(shoppingBannerShell);
			let $bannerParent = jQuery('.products-cart-banner'); // document.querySelector('.products-cart-banner');

			if (clonSecNav && $bannerParent) {
				$bannerParent.append(jQuery(clonSecNav));
			}
		}
		onAppMounted();
	}

	init();
}

export default ShoppingCartBanner;

/* v1.0 */
